// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/requests_service.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { User } from "../../customer/management/v1/service_pb";
import { file_customer_management_v1_service } from "../../customer/management/v1/service_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { IntakeQuestionAnswerValue, SubmitIntakeFormRequest } from "./company_intake_pb";
import { file_inventory_v1_company_intake } from "./company_intake_pb";
import type { CompanyLifecycle } from "./company_lifecycle_pb";
import { file_inventory_v1_company_lifecycle } from "./company_lifecycle_pb";
import type { BusinessOwner, CompanyProfile, CustomFieldValue, InherentRiskGroup, PointOfContact, Source } from "./company_service_pb";
import { file_inventory_v1_company_service } from "./company_service_pb";
import type { CompanySummary } from "./company_summary_pb";
import { file_inventory_v1_company_summary } from "./company_summary_pb";
import type { RiskLevel } from "./risk_pb";
import { file_inventory_v1_risk } from "./risk_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/requests_service.proto.
 */
export const file_inventory_v1_requests_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_customer_management_v1_service, file_google_protobuf_timestamp, file_inventory_v1_company_intake, file_inventory_v1_company_lifecycle, file_inventory_v1_company_service, file_inventory_v1_company_summary, file_inventory_v1_risk]);

/**
 * @generated from message inventory.v1.Request
 */
export type Request = Message<"inventory.v1.Request"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string company_id = 2;
   */
  companyId?: string;

  /**
   * @generated from field: bool is_new_company = 3;
   */
  isNewCompany: boolean;

  /**
   * @generated from field: bool is_edit_company_allowed = 4;
   */
  isEditCompanyAllowed: boolean;

  /**
   * @generated from field: optional inventory.v1.ProcurementRequestStatus procurement_request_status = 5;
   */
  procurementRequestStatus?: ProcurementRequestStatus;

  /**
   * @generated from field: string source = 6;
   */
  source: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string request_name = 9;
   */
  requestName: string;

  /**
   * @generated from field: string vendor_id = 10;
   */
  vendorId: string;

  /**
   * @generated from field: string vendor_name = 11;
   */
  vendorName: string;

  /**
   * @generated from field: optional string vendor_website = 12;
   */
  vendorWebsite?: string;

  /**
   * @generated from field: optional inventory.v1.CompanyLifecycle vendor_lifecycle = 13;
   */
  vendorLifecycle?: CompanyLifecycle;

  /**
   * @generated from field: inventory.v1.CompanyProfile company_profile = 14;
   */
  companyProfile?: CompanyProfile;

  /**
   * The ID we show to users, should be human readable
   *
   * @generated from field: string request_display_id = 15;
   */
  requestDisplayId: string;

  /**
   * @generated from oneof inventory.v1.Request.info
   */
  info: {
    /**
     * @generated from field: inventory.v1.RequestInfo request_info = 16;
     */
    value: RequestInfo;
    case: "requestInfo";
  } | {
    /**
     * @generated from field: inventory.v1.SubmitIntakeFormRequest intake_form = 17;
     */
    value: SubmitIntakeFormRequest;
    case: "intakeForm";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: optional inventory.v1.BusinessOwner requester = 18;
   */
  requester?: BusinessOwner;

  /**
   * Whether the request was auto-approved by an integration's auto-approve flow
   *
   * @generated from field: bool auto_approved = 19;
   */
  autoApproved: boolean;
};

/**
 * Describes the message inventory.v1.Request.
 * Use `create(RequestSchema)` to create a new message.
 */
export const RequestSchema: GenMessage<Request> = /*@__PURE__*/
  messageDesc(file_inventory_v1_requests_service, 0);

/**
 * @generated from message inventory.v1.RequestInfo
 */
export type RequestInfo = Message<"inventory.v1.RequestInfo"> & {
  /**
   * @generated from field: inventory.v1.GeneralInfo general = 1;
   */
  general?: GeneralInfo;

  /**
   * @generated from field: repeated inventory.v1.CustomFieldValue custom_fields = 2;
   */
  customFields: CustomFieldValue[];
};

/**
 * Describes the message inventory.v1.RequestInfo.
 * Use `create(RequestInfoSchema)` to create a new message.
 */
export const RequestInfoSchema: GenMessage<RequestInfo> = /*@__PURE__*/
  messageDesc(file_inventory_v1_requests_service, 1);

/**
 * @generated from message inventory.v1.GeneralInfo
 */
export type GeneralInfo = Message<"inventory.v1.GeneralInfo"> & {
  /**
   * @generated from field: optional string request_description = 1;
   */
  requestDescription?: string;

  /**
   * @generated from field: optional string category = 2;
   */
  category?: string;

  /**
   * @generated from field: optional string sub_category = 3;
   */
  subCategory?: string;

  /**
   * @generated from field: optional string department_id = 4;
   */
  departmentId?: string;

  /**
   * @generated from field: optional string department_name = 5;
   */
  departmentName?: string;

  /**
   * @generated from field: optional double spend_amount = 6;
   */
  spendAmount?: number;

  /**
   * @generated from field: optional string spend_currency = 7;
   */
  spendCurrency?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp spend_start_time = 8;
   */
  spendStartTime?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp spend_end_time = 9;
   */
  spendEndTime?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp execution_date = 10;
   */
  executionDate?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp renewal_date = 11;
   */
  renewalDate?: Timestamp;

  /**
   * @generated from field: optional string request_url = 12;
   */
  requestUrl?: string;

  /**
   * @generated from field: optional string vendor_status = 13;
   */
  vendorStatus?: string;

  /**
   * @generated from field: repeated inventory.v1.PointOfContact point_of_contacts = 14;
   */
  pointOfContacts: PointOfContact[];

  /**
   * @generated from field: repeated inventory.v1.BusinessOwner business_owners = 15;
   */
  businessOwners: BusinessOwner[];

  /**
   * @generated from field: repeated inventory.v1.ProcurementArtifact artifacts = 16;
   */
  artifacts: ProcurementArtifact[];

  /**
   * @generated from field: repeated inventory.v1.ProcurementQuestionnaire questionnaires = 17;
   */
  questionnaires: ProcurementQuestionnaire[];

  /**
   * @generated from field: inventory.v1.CompanySummary company_summary = 18;
   */
  companySummary?: CompanySummary;

  /**
   * @generated from field: optional customer.management.v1.User decision_by_user = 19;
   */
  decisionByUser?: User;

  /**
   * @generated from field: optional google.protobuf.Timestamp decision_at = 20;
   */
  decisionAt?: Timestamp;

  /**
   * @generated from field: optional string parent_company_id = 21;
   */
  parentCompanyId?: string;

  /**
   * @generated from field: optional inventory.v1.IntakeApprovalEngagement engagement = 22;
   */
  engagement?: IntakeApprovalEngagement;

  /**
   * @generated from field: repeated inventory.v1.LemaIntakeSectionData lema_intake_data = 23;
   */
  lemaIntakeData: LemaIntakeSectionData[];

  /**
   * @generated from field: repeated inventory.v1.BusinessContextEntry business_context = 24;
   */
  businessContext: BusinessContextEntry[];

  /**
   * @generated from field: optional inventory.v1.RiskLevel inherent_risk_level = 25;
   */
  inherentRiskLevel?: RiskLevel;

  /**
   * @generated from field: repeated inventory.v1.InherentRiskGroup inherent_risk_questionnaire = 26;
   */
  inherentRiskQuestionnaire: InherentRiskGroup[];

  /**
   * @generated from field: string raw_payload = 27;
   */
  rawPayload: string;
};

/**
 * Describes the message inventory.v1.GeneralInfo.
 * Use `create(GeneralInfoSchema)` to create a new message.
 */
export const GeneralInfoSchema: GenMessage<GeneralInfo> = /*@__PURE__*/
  messageDesc(file_inventory_v1_requests_service, 2);

/**
 * @generated from message inventory.v1.BusinessContextEntry
 */
export type BusinessContextEntry = Message<"inventory.v1.BusinessContextEntry"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Populated when the upstream data is a scalar/array — formatted single-line value.
   *
   * @generated from field: string value = 2;
   */
  value: string;

  /**
   * Populated when the upstream data is an object — each scalar sub-field as label/value.
   *
   * @generated from field: repeated inventory.v1.BusinessContextObjectField object_fields = 3;
   */
  objectFields: BusinessContextObjectField[];
};

/**
 * Describes the message inventory.v1.BusinessContextEntry.
 * Use `create(BusinessContextEntrySchema)` to create a new message.
 */
export const BusinessContextEntrySchema: GenMessage<BusinessContextEntry> = /*@__PURE__*/
  messageDesc(file_inventory_v1_requests_service, 3);

/**
 * @generated from message inventory.v1.BusinessContextObjectField
 */
export type BusinessContextObjectField = Message<"inventory.v1.BusinessContextObjectField"> & {
  /**
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message inventory.v1.BusinessContextObjectField.
 * Use `create(BusinessContextObjectFieldSchema)` to create a new message.
 */
export const BusinessContextObjectFieldSchema: GenMessage<BusinessContextObjectField> = /*@__PURE__*/
  messageDesc(file_inventory_v1_requests_service, 4);

/**
 * @generated from message inventory.v1.LemaIntakeSectionData
 */
export type LemaIntakeSectionData = Message<"inventory.v1.LemaIntakeSectionData"> & {
  /**
   * @generated from field: string section_name = 1;
   */
  sectionName: string;

  /**
   * @generated from field: repeated inventory.v1.LemaIntakeQuestionData questions = 2;
   */
  questions: LemaIntakeQuestionData[];
};

/**
 * Describes the message inventory.v1.LemaIntakeSectionData.
 * Use `create(LemaIntakeSectionDataSchema)` to create a new message.
 */
export const LemaIntakeSectionDataSchema: GenMessage<LemaIntakeSectionData> = /*@__PURE__*/
  messageDesc(file_inventory_v1_requests_service, 5);

/**
 * @generated from message inventory.v1.LemaIntakeQuestionData
 */
export type LemaIntakeQuestionData = Message<"inventory.v1.LemaIntakeQuestionData"> & {
  /**
   * @generated from field: string question_name = 1;
   */
  questionName: string;

  /**
   * @generated from field: inventory.v1.IntakeQuestionAnswerValue answer = 2;
   */
  answer?: IntakeQuestionAnswerValue;
};

/**
 * Describes the message inventory.v1.LemaIntakeQuestionData.
 * Use `create(LemaIntakeQuestionDataSchema)` to create a new message.
 */
export const LemaIntakeQuestionDataSchema: GenMessage<LemaIntakeQuestionData> = /*@__PURE__*/
  messageDesc(file_inventory_v1_requests_service, 6);

/**
 * @generated from message inventory.v1.ProcurementArtifact
 */
export type ProcurementArtifact = Message<"inventory.v1.ProcurementArtifact"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string external_id = 3;
   */
  externalId: string;

  /**
   * @generated from field: string source = 4;
   */
  source: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message inventory.v1.ProcurementArtifact.
 * Use `create(ProcurementArtifactSchema)` to create a new message.
 */
export const ProcurementArtifactSchema: GenMessage<ProcurementArtifact> = /*@__PURE__*/
  messageDesc(file_inventory_v1_requests_service, 7);

/**
 * @generated from message inventory.v1.ProcurementQuestionnaire
 */
export type ProcurementQuestionnaire = Message<"inventory.v1.ProcurementQuestionnaire"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string questionnaire_id = 3;
   */
  questionnaireId: string;

  /**
   * @generated from field: optional string status = 4;
   */
  status?: string;

  /**
   * @generated from field: optional int32 question_count = 5;
   */
  questionCount?: number;

  /**
   * @generated from field: optional string request_url = 6;
   */
  requestUrl?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message inventory.v1.ProcurementQuestionnaire.
 * Use `create(ProcurementQuestionnaireSchema)` to create a new message.
 */
export const ProcurementQuestionnaireSchema: GenMessage<ProcurementQuestionnaire> = /*@__PURE__*/
  messageDesc(file_inventory_v1_requests_service, 8);

/**
 * @generated from message inventory.v1.RequestSummary
 */
export type RequestSummary = Message<"inventory.v1.RequestSummary"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string request_name = 2;
   */
  requestName: string;

  /**
   * @generated from field: optional inventory.v1.ProcurementRequestStatus request_status = 3;
   */
  requestStatus?: ProcurementRequestStatus;

  /**
   * @generated from field: string vendor_name = 4;
   */
  vendorName: string;

  /**
   * @generated from field: bool is_new_company = 5;
   */
  isNewCompany: boolean;

  /**
   * @generated from field: inventory.v1.Source source = 6;
   */
  source?: Source;

  /**
   * @generated from field: optional string department_name = 7;
   */
  departmentName?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional inventory.v1.BusinessOwner requester = 10;
   */
  requester?: BusinessOwner;

  /**
   * The ID we show to users, should be human readable
   *
   * @generated from field: string request_display_id = 11;
   */
  requestDisplayId: string;

  /**
   * Whether the request was auto-approved by an integration's auto-approve flow
   *
   * @generated from field: bool auto_approved = 12;
   */
  autoApproved: boolean;

  /**
   * Company website, used to resolve the company logo. Empty when unknown.
   *
   * @generated from field: string profile_website = 13;
   */
  profileWebsite: string;
};

/**
 * Describes the message inventory.v1.RequestSummary.
 * Use `create(RequestSummarySchema)` to create a new message.
 */
export const RequestSummarySchema: GenMessage<RequestSummary> = /*@__PURE__*/
  messageDesc(file_inventory_v1_requests_service, 9);

/**
 * @generated from message inventory.v1.ListRequestsRequest
 */
export type ListRequestsRequest = Message<"inventory.v1.ListRequestsRequest"> & {
  /**
   * @generated from field: optional string org_company_id = 1;
   */
  orgCompanyId?: string;

  /**
   * @generated from field: optional inventory.v1.ProcurementRequestStatus request_status = 2;
   */
  requestStatus?: ProcurementRequestStatus;
};

/**
 * Describes the message inventory.v1.ListRequestsRequest.
 * Use `create(ListRequestsRequestSchema)` to create a new message.
 */
export const ListRequestsRequestSchema: GenMessage<ListRequestsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_requests_service, 10);

/**
 * @generated from message inventory.v1.ListRequestsResponse
 */
export type ListRequestsResponse = Message<"inventory.v1.ListRequestsResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.RequestSummary requests = 1;
   */
  requests: RequestSummary[];
};

/**
 * Describes the message inventory.v1.ListRequestsResponse.
 * Use `create(ListRequestsResponseSchema)` to create a new message.
 */
export const ListRequestsResponseSchema: GenMessage<ListRequestsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_requests_service, 11);

/**
 * @generated from message inventory.v1.GetRequestRequest
 */
export type GetRequestRequest = Message<"inventory.v1.GetRequestRequest"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;
};

/**
 * Describes the message inventory.v1.GetRequestRequest.
 * Use `create(GetRequestRequestSchema)` to create a new message.
 */
export const GetRequestRequestSchema: GenMessage<GetRequestRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_requests_service, 12);

/**
 * @generated from message inventory.v1.GetRequestResponse
 */
export type GetRequestResponse = Message<"inventory.v1.GetRequestResponse"> & {
  /**
   * @generated from field: inventory.v1.Request request = 1;
   */
  request?: Request;
};

/**
 * Describes the message inventory.v1.GetRequestResponse.
 * Use `create(GetRequestResponseSchema)` to create a new message.
 */
export const GetRequestResponseSchema: GenMessage<GetRequestResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_requests_service, 13);

/**
 * @generated from message inventory.v1.IntakeApprovalEngagement
 */
export type IntakeApprovalEngagement = Message<"inventory.v1.IntakeApprovalEngagement"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: optional string description = 2;
   */
  description?: string;

  /**
   * Populated for read (GetRequest) when the request carries an engagement
   * payload, so the drawer can render the full engagement section.
   *
   * @generated from field: optional inventory.v1.PointOfContact point_of_contact = 3;
   */
  pointOfContact?: PointOfContact;

  /**
   * @generated from field: optional inventory.v1.BusinessOwner owner = 4;
   */
  owner?: BusinessOwner;

  /**
   * @generated from field: repeated inventory.v1.CustomFieldValue custom_fields = 5;
   */
  customFields: CustomFieldValue[];

  /**
   * Product id when the approver picked an entry from the product autocomplete.
   *
   * @generated from field: optional string product_id = 6;
   */
  productId?: string;
};

/**
 * Describes the message inventory.v1.IntakeApprovalEngagement.
 * Use `create(IntakeApprovalEngagementSchema)` to create a new message.
 */
export const IntakeApprovalEngagementSchema: GenMessage<IntakeApprovalEngagement> = /*@__PURE__*/
  messageDesc(file_inventory_v1_requests_service, 14);

/**
 * @generated from message inventory.v1.ApproveRequestRequest
 */
export type ApproveRequestRequest = Message<"inventory.v1.ApproveRequestRequest"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: optional inventory.v1.IntakeApprovalEngagement engagement = 2;
   */
  engagement?: IntakeApprovalEngagement;

  /**
   * In case the company has no engagements yet, we need to create a default one.
   *
   * @generated from field: optional inventory.v1.IntakeApprovalEngagement default_engagement = 3;
   */
  defaultEngagement?: IntakeApprovalEngagement;
};

/**
 * Describes the message inventory.v1.ApproveRequestRequest.
 * Use `create(ApproveRequestRequestSchema)` to create a new message.
 */
export const ApproveRequestRequestSchema: GenMessage<ApproveRequestRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_requests_service, 15);

/**
 * @generated from message inventory.v1.ApproveRequestResponse
 */
export type ApproveRequestResponse = Message<"inventory.v1.ApproveRequestResponse"> & {
  /**
   * @generated from field: string org_company_id = 1;
   */
  orgCompanyId: string;
};

/**
 * Describes the message inventory.v1.ApproveRequestResponse.
 * Use `create(ApproveRequestResponseSchema)` to create a new message.
 */
export const ApproveRequestResponseSchema: GenMessage<ApproveRequestResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_requests_service, 16);

/**
 * @generated from message inventory.v1.RejectRequestRequest
 */
export type RejectRequestRequest = Message<"inventory.v1.RejectRequestRequest"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: optional string note = 2;
   */
  note?: string;
};

/**
 * Describes the message inventory.v1.RejectRequestRequest.
 * Use `create(RejectRequestRequestSchema)` to create a new message.
 */
export const RejectRequestRequestSchema: GenMessage<RejectRequestRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_requests_service, 17);

/**
 * @generated from message inventory.v1.RejectRequestResponse
 */
export type RejectRequestResponse = Message<"inventory.v1.RejectRequestResponse"> & {
};

/**
 * Describes the message inventory.v1.RejectRequestResponse.
 * Use `create(RejectRequestResponseSchema)` to create a new message.
 */
export const RejectRequestResponseSchema: GenMessage<RejectRequestResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_requests_service, 18);

/**
 * @generated from message inventory.v1.EditRequestCompanyRequest
 */
export type EditRequestCompanyRequest = Message<"inventory.v1.EditRequestCompanyRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string new_company_pdl_id = 2;
   */
  newCompanyPdlId?: string;

  /**
   * @generated from field: optional string new_company_id = 3;
   */
  newCompanyId?: string;

  /**
   * @generated from field: string new_company_name = 4;
   */
  newCompanyName: string;

  /**
   * @generated from field: string new_company_website = 5;
   */
  newCompanyWebsite: string;
};

/**
 * Describes the message inventory.v1.EditRequestCompanyRequest.
 * Use `create(EditRequestCompanyRequestSchema)` to create a new message.
 */
export const EditRequestCompanyRequestSchema: GenMessage<EditRequestCompanyRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_requests_service, 19);

/**
 * @generated from message inventory.v1.EditRequestCompanyResponse
 */
export type EditRequestCompanyResponse = Message<"inventory.v1.EditRequestCompanyResponse"> & {
};

/**
 * Describes the message inventory.v1.EditRequestCompanyResponse.
 * Use `create(EditRequestCompanyResponseSchema)` to create a new message.
 */
export const EditRequestCompanyResponseSchema: GenMessage<EditRequestCompanyResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_requests_service, 20);

/**
 * @generated from message inventory.v1.EditRequestRequest
 */
export type EditRequestRequest = Message<"inventory.v1.EditRequestRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional inventory.v1.CompanyLifecycle lifecycle = 2;
   */
  lifecycle?: CompanyLifecycle;

  /**
   * @generated from field: optional string parent_company_id = 3;
   */
  parentCompanyId?: string;
};

/**
 * Describes the message inventory.v1.EditRequestRequest.
 * Use `create(EditRequestRequestSchema)` to create a new message.
 */
export const EditRequestRequestSchema: GenMessage<EditRequestRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_requests_service, 21);

/**
 * @generated from message inventory.v1.EditRequestResponse
 */
export type EditRequestResponse = Message<"inventory.v1.EditRequestResponse"> & {
};

/**
 * Describes the message inventory.v1.EditRequestResponse.
 * Use `create(EditRequestResponseSchema)` to create a new message.
 */
export const EditRequestResponseSchema: GenMessage<EditRequestResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_requests_service, 22);

/**
 * @generated from enum inventory.v1.ProcurementRequestStatus
 */
export enum ProcurementRequestStatus {
  /**
   * @generated from enum value: PROCUREMENT_REQUEST_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROCUREMENT_REQUEST_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: PROCUREMENT_REQUEST_STATUS_APPROVED = 2;
   */
  APPROVED = 2,

  /**
   * @generated from enum value: PROCUREMENT_REQUEST_STATUS_REJECTED = 3;
   */
  REJECTED = 3,
}

/**
 * Describes the enum inventory.v1.ProcurementRequestStatus.
 */
export const ProcurementRequestStatusSchema: GenEnum<ProcurementRequestStatus> = /*@__PURE__*/
  enumDesc(file_inventory_v1_requests_service, 0);

/**
 * @generated from service inventory.v1.RequestsService
 */
export const RequestsService: GenService<{
  /**
   * @generated from rpc inventory.v1.RequestsService.ListRequests
   */
  listRequests: {
    methodKind: "unary";
    input: typeof ListRequestsRequestSchema;
    output: typeof ListRequestsResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.RequestsService.GetRequest
   */
  getRequest: {
    methodKind: "unary";
    input: typeof GetRequestRequestSchema;
    output: typeof GetRequestResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.RequestsService.ApproveRequest
   */
  approveRequest: {
    methodKind: "unary";
    input: typeof ApproveRequestRequestSchema;
    output: typeof ApproveRequestResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.RequestsService.RejectRequest
   */
  rejectRequest: {
    methodKind: "unary";
    input: typeof RejectRequestRequestSchema;
    output: typeof RejectRequestResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.RequestsService.EditRequestCompany
   */
  editRequestCompany: {
    methodKind: "unary";
    input: typeof EditRequestCompanyRequestSchema;
    output: typeof EditRequestCompanyResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.RequestsService.EditRequest
   */
  editRequest: {
    methodKind: "unary";
    input: typeof EditRequestRequestSchema;
    output: typeof EditRequestResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_inventory_v1_requests_service, 0);

